module.exports = __webpack_public_path__ + "static/media/SupportCenter.09dca046.svg";